import { AppModel } from "@essenza/core";
import { Formix, FormixItem, useForm, useControl, useGraph } from "@essenza/react";
import { Button, Input, message, Select, Upload } from 'antd';

import React, { useState } from "react";
import ImgCrop from 'antd-img-crop';
import * as yup from 'yup';
import { AreaModel } from "../models/DBModel";

import { UploadOutlined } from '@ant-design/icons';

const { Option } = Select;

function CompanyProfileController(c) {
    c.skin = CompanyProfile;
    c.command = {
        SAVE: async (path, { control, model }) => {
            //console.log("SAVE", source);
            let form = control.form("cprofile-form");
            let result = await form.validate();
            console.log("PROFILE FORM VALIDATION", form, result);
            //message.warning("VERSIONE DEMO! i dati non verranno salvati per questa demo.", 2);
            //return;
            if (result.isValid) {
                const complete = result.data.complete;
                if(!complete){
                    result.node.mutate("complete", true, result.data);
                }
                    
                result.node.save().then((r) => {
                    if (path)
                        control.navigate(path);
                    if(!complete)
                        c.app.session.complete = true;
                    message.info('Profilo aggiornato con successo!', 2);
                });
            }
        },
    }
}

export function CompanyProfile({ source, label, title, npath }) {
    //const source = useGraph2(LessonModel, "item");
    const [control] = useControl(CompanyProfileController);
    const roles = useGraph(AreaModel, "list");
    //const form = useForm("profile-form", source, control);
    const form = useForm("cprofile-form", source, control, null, yup.object({
        tbusinessname: yup.string().required("Nome Azienda è una informazione richiesta."),
        taddress: yup.string().required("Indirizzo è una informazione richiesta."),
        tsite: yup.string().required("Città è una informazione richiesta."),
        cap: yup.string().required("Cap è una informazione richiesta."),
        idbusiness: yup.number().typeError("Settore Business è una informazione richiesta."),
    })); //, {itype: (v) => v === "1"}

    const img = source.data?.img;
    const [fileList, setFileList] = useState([
        {
            uid: '-1',
            //name: 'immagineprofilo.jpg',
            status: 'done',
            url: (img || '/img/profile/user.png') + '?' + new Date().getTime(),
        },
    ]);

    const ionSuccess = (r) => {
        message.success("Immagine caricata con successo!");
    }

    const onChange = ({ fileList: newFileList }) => {
        debugger
        newFileList[1].status = "done";
        setFileList([newFileList[1]]);
    };

    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };

    const ibeforeUpload = (file) => {
        if (file.type === 'image/jpeg' || file.type === 'image/png')
            return true;
        else {
            control.openPopup(<div>Formato file non supporto. Formato supportato jpg, png.</div>)
            return Upload.LIST_IGNORE;
        }
    };
    return (
        <>
            <div className="custom-form bg-pri round-sm mt-sm padding-xl text-left">
                <Formix control={control} form={form} layout='vertical' >
                    {/* <h2 className="pb-md">Informazioni personali</h2> */}
                    <FormixItem label="Nome Azienda" name="tbusinessname">
                        <Input placeholder=""></Input>
                    </FormixItem>
                    <FormixItem label="Indirizzo" name="taddress">
                        <Input placeholder=""></Input>
                    </FormixItem>
                    <FormixItem label="CAP" name="cap">
                        <Input placeholder=""></Input>
                    </FormixItem>
                    <FormixItem label="Città" name="tsite">
                        <Input placeholder="Es. Firenze"></Input>
                    </FormixItem>
                    <FormixItem label="URL sito web" name="twebsiteurl" >
                        <Input placeholder=""></Input>
                    </FormixItem>
                    <FormixItem label="Settore Business" name="idbusiness">
                        <Select placeholder="Settore di business" className="select-flex-w w100">
                            {/* <Option value={null}>Settore di business</Option> */}
                            {Array.isArray(roles.data) && roles.data.map((v) => <Option value={v.id}>{v.name}</Option>)}
                        </Select>
                    </FormixItem>
                    <FormixItem label="Range" name="irange">
                        <Select placeholder="Range" className="select-flex-w w100">
                            <Option value={1}>0-10 dipendenti</Option>
                            <Option value={2}>11-49 dipendenti</Option>
                            <Option value={3}>50-249 dipendenti</Option>
                            <Option value={4}>+249 dipendenti</Option>
                        </Select>
                    </FormixItem>
                    <FormixItem label="Carica Logo Aziendale" name="taddress" extra="Formato consigliato 300px x 300px">
                        <ImgCrop rotate shape="round" >
                            <Upload name="image"  beforeUpload={ibeforeUpload} onSuccess={ionSuccess} customRequest={control.upload} data={{ url: 'api/uprofile' }}
                                listType="picture-card"
                                fileList={fileList}
                                onChange={onChange}
                                onPreview={onPreview}>
                                {fileList.length < 2 && <div className="block-pri w100 h100"><UploadOutlined className="pr-sm" />Carica</div>}
                            </Upload>
                        </ImgCrop>
                    </FormixItem>
                    <div className="right-align">
                        <Button className="primaryButton" onClick={() => control.execute("SAVE", npath)}>
                            Aggiorna
                        </Button>
                    </div>
                </Formix>
            </div>
        </>
    )
}